(() => {
  'use strict';

  const selectors = {
    productsHolder: '[data-cross-sell-products]',
    widget: '[data-cross-sell-widget]',
    skipButton: '[data-skip-upsell-product]',
    quickAddHolder: '[data-quick-add-holder]',
  };

  const attributes = {
    quickAddHolder: 'data-quick-add-holder',
    autoOpen: 'data-upsell-auto-open',
  };

  const sessionKey = 'skip_cross_sell_products';

  customElements.get('cart-cross-sell') ||
    customElements.define(
      'cart-cross-sell',
      class CartCrossSell extends HTMLElement {
        connectedCallback() {
          this.holder = this.querySelector(selectors.productsHolder);
          this.widget = this.closest(selectors.widget);
          this.sectionId = this.dataset.sectionId || 'api-cross-sell';
          this.limit = parseInt(this.dataset.limit) || 4;
          this.skipArray = this.getSkipped();

          this.load();

          document.addEventListener('theme:cart:change', () => this.load());
        }

        getSkipped() {
          try {
            return JSON.parse(sessionStorage.getItem(sessionKey) || '[]');
          } catch {
            return [];
          }
        }

        async load() {
          if (!this.holder) return;

          try {
            const cart = await fetch('/cart.js').then((r) => r.json());

            if (!cart.items || cart.items.length === 0) {
              this.showWidget(false);
              return;
            }

            const productId = cart.items[0].product_id;
            const fetchLimit = this.limit + this.skipArray.length;
            const url = `${window.theme.routes.product_recommendations_url}?section_id=${this.sectionId}&product_id=${productId}&limit=${fetchLimit}&intent=related`;

            const text = await fetch(url).then((r) => r.text());
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const content = doc.querySelector('[data-api-content]');

            if (!content) {
              this.showWidget(false);
              return;
            }

            this.holder.innerHTML = content.innerHTML;

            // Remove previously skipped products
            this.skipArray.forEach((id) => {
              const el = this.holder.querySelector(`[${attributes.quickAddHolder}="${id}"]`);
              if (el) el.closest('quick-add-product')?.remove();
            });

            // Enforce visible limit after removing skipped
            const items = Array.from(this.holder.querySelectorAll('quick-add-product'));
            items.slice(this.limit).forEach((el) => el.remove());

            this.showWidget(this.holder.querySelector('quick-add-product') !== null);
            this.bindSkipButtons();
          } catch {
            this.showWidget(false);
          }
        }

        bindSkipButtons() {
          this.holder.querySelectorAll(selectors.skipButton).forEach((btn) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              const holder = btn.closest(selectors.quickAddHolder);
              if (!holder) return;
              const id = holder.getAttribute(attributes.quickAddHolder);

              if (!this.skipArray.includes(id)) {
                this.skipArray.push(id);
                sessionStorage.setItem(sessionKey, JSON.stringify(this.skipArray));
              }

              holder.closest('quick-add-product')?.remove();

              const remaining = this.holder.querySelectorAll('quick-add-product');
              this.showWidget(remaining.length > 0);
            });
          });
        }

        showWidget(visible) {
          if (!this.widget) return;
          this.widget.toggleAttribute('hidden', !visible);

          if (visible && this.widget.hasAttribute(attributes.autoOpen)) {
            this.widget.setAttribute('open', 'true');
            const body = this.widget.querySelector('[data-collapsible-body]');
            if (body) body.style.height = 'auto';
          }
        }
      }
    );
})();